import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class ConsultaPrestamosService 
{
    constructor(public http: HttpClient, ) { }

    postulacionesDisponibles(usuario: any,rol:any){
        return this.http.get(`${environment.urlApiPrestamo}/postulacionesDisponibles/${usuario}/rol/${rol}`, 
        { headers: this.armaCabecera() }).toPromise();
    }
    postulacionesDisponiblesBuscador(usuario: any,rol:any,buscador:any,email:any){
      console.log("buscador!!!", buscador);
        return this.http.post(`${environment.urlApiPrestamo}/postulacionesDisponibles/buscador/`,
        {
            filtroIngresado:true,
            email: email,
            rol:rol,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idSolicitud: buscador?.idSolicitud,
            idRegion: buscador?.region,
            rut: buscador?.rut,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            estado: buscador?.estado
         
        }, 
        { headers: this.armaCabecera() }).toPromise();
    }
    traePostulacionesAsignadas(usuario:any,buscador:any,estadoSeleccionado:any){
        
        return this.http.post(`${environment.urlApiPrestamo}/postulaciones/asignadas/ejecutivos/id/`,
        {
            idUsuarioAsig: usuario,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idRegion: buscador?.region,   
            idSolicitud: buscador?.idSolicitud,
            rut: buscador?.rut,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            estado: estadoSeleccionado
        },
        { headers: this.armaCabecera() }).toPromise();
    }
    traeMontoTotalDisponible(idUsuario : any){
        return this.http.get(`${environment.urlApiPrestamo}/totalDisponible/${idUsuario}`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeUsuario(rut: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/afiliados/rut/${rut}`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeCantidadCuotas(){
        
        return this.http.get(`${environment.urlApiPrestamo}/getCantidadCuotas`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
    traeTipoPrestamo(){
        
        return this.http.get(`${environment.urlApiPrestamo}/getTipoPrestamo`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
  
    guardarEdicion(prestamo:any,idEjecutivo:any){
        return this.http.post(`${environment.urlApiPrestamo}/prestamo/guardar`,
        {
           
            idCarga:0,
            idProducto: 4,
            archivoAdjunto:  prestamo.archivo,     
            idEjecutivo: idEjecutivo,   
            prestamo:  {
                montoSolicitado: prestamo.montoSolicitado,
                cantidadCuota:prestamo.cantidadCuotas,
                montoTotalCuota: prestamo.montoTotalCuota,
                tipoPrestamo:prestamo.tipoPrestamo,
                totalCuota:prestamo.montoCuota,
                idAfiliado:prestamo.idAfiliado,
                idUsuario:prestamo.idUsuario,
                idPrestamo:prestamo.idPrestamo,
                fechaPrimerPago:prestamo.fechaPrimerPago,
                idPostulacion: prestamo.idPostulacion,
                tasaInteres:(prestamo.montoTotalCuota-prestamo.montoCuota),
                montoCuota: prestamo.montoCuota,
                planes: prestamo.planes
                 }
             
            
          //  notificacion: { email:escolaridad.email, nombreCompleto:nombreUsuario, nombreProducto: 'PRESTAMO' }

        },

        { headers: this.armaCabecera() }).toPromise();
    }
    postulacionesCodeudor(usuario: any){
        return this.http.get(`${environment.urlApiPrestamo}/postulacionesCodeudor/${usuario}`,
        { headers: this.armaCabecera() }).toPromise();

    }
    motivoRechazo(idProducto: any)
    {
        return this.http.get(`${environment.urlApiPrestamo}/motivoRechazo/productos/${idProducto}/`,
               { headers:this.armaCabecera() }).toPromise()
    }
    traeArchivos(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/archivo-adjunto/`,
               { headers:this.armaCabecera() }).toPromise()
    }
    cambiarEstadoPostulacion(idPostulacion: any, estado: any)
    {
        return this.http.post(`${environment.urlApiPrestamo}/solicitudes/`,
               { id: idPostulacion, estado: estado }, { headers:this.armaCabecera() } ).toPromise();
    }
    traePrestamo(id: any,mostrarEditar:any){
       
        return this.http.get(`${environment.urlApiPrestamo}/prestamo/${id}`, 
        { headers: this.armaCabecera() }).toPromise();
    }

    traePrestamoGestionar(id: any,mostrarEditar:any){
       
        return this.http.get(`${environment.urlApiPrestamo}/prestamoGestionar/${id}`, 
        { headers: this.armaCabecera() }).toPromise();
    }

    traePostulantes(rut: any)
    {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`, 
               { headers: this.armaCabecera() }).toPromise();
    }
    asignaPostulacion(postulaciones: any, idEjecutivo: any)
    {
        return this.http.post(`${environment.urlApiPrestamo}/prestamo/asignar/ejecutivo/${idEjecutivo}`,
        postulaciones, { headers:this.armaCabecera() } ).toPromise()
    }
    traeRegiones()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/regiones`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeEstados()
    {
        return this.http.get(`${environment.urlApiPrestamo}/postulaciones/estados`,
        { headers:this.armaCabecera() }).toPromise();
    }
    rechazarSerCodeudor(prestamo:any, idCodeudor: any,resultado:any){
        return this.http.post(`${environment.urlApiPrestamo}/solicitud/codeudor/rechazar`,
        {   idPostulacion:prestamo.idPostulacion,
            idPrestamo:prestamo.idPrestamo,
            idCodeudor:idCodeudor,
            prestamo:{ idPostulacion:prestamo.idPostulacion,
                        idPrestamo:prestamo.idPrestamo,
                        idUsuario: idCodeudor}
        }
        ,{ headers:this.armaCabecera() }).toPromise();
    }
    aprobarSerCodeudor(prestamo:any, idCodeudor: any,resultado:any){
        
        return this.http.post(`${environment.urlApiPrestamo}/solicitud/codeudor/aprobar`,
        {      idPostulacion:prestamo.idPostulacion,
            idPrestamo:prestamo.idPrestamo,
            idCodeudor:idCodeudor,
            prestamo:{ idPostulacion:prestamo.idPostulacion,
                        idPrestamo:prestamo.idPrestamo,
                        idUsuario: idCodeudor},
            archivoAdjunto: prestamo.archivos            
           // archivoAdjunto: [ { url: "", archivo: archivo.archivo, extension:archivo.extension } ]
        }
        ,{ headers:this.armaCabecera() }).toPromise();

    }
   
    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}